export const fromNumber = (val: number, decimals: number = 0): string => Intl.NumberFormat("en-UK", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
}).format(val);
